export enum ROLE  {
    Admin = 'ADMIN',
    User = 'USER'
}